/* eslint-disable no-nested-ternary */
import BasePresenter from '@src/js/separate-logic/base-presenter';
import { external } from '@src/js/separate-logic/decorate/external';
import { dispatchProps } from '@src/js/separate-logic/decorate/dispatchProps';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import {
    TDWActionType,
    TDWModuleType,
    TDWOperationType,
} from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import { SelectedEleMgrType } from '@src/slide/domain/selection/constant/select-element-type';
import { PPTEditorStateType } from '@src/slide/domain/ui-model/constant/edit-state-type';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { IEditorAppServices } from '@src/slide/application/entry/toc/editor/base/base-editor-app-service.interface';
import { IUserPriviledgeService } from '@src/slide/application/service/user-priviledge-service/user-priviledge-service.interface';
import { IPcEditorAppServices } from '@src/slide/application/entry/toc/editor/pc/pc-editor-app-services.interface';
import { GroupRefreshMenu } from '@src/slide/domain/ui-model/element-modeles/property/menu-property/refresh/group';

export default class GroupElementPresenter extends BasePresenter {
    private componentProps: any = null;
    private needMouseUp: boolean | null = null;
    public init(props: any) {
        this.componentProps = props.component.props;
    }

    public componentDidMount() {
        GroupRefreshMenu.caculateItemValues(this.props.component);
    }
    public componentDidUpdate() {
        if (!this.props.fromScale) {
            this.props.onElementUpdate?.();
        }
    }

    @dispatchProps()
    public handleMouseDown = (childModel, e) => {
        const { isRootGroup } = this.props.component;
        if (isRootGroup) {
            this.handleMouseDownPresenter(childModel, e);
        } else {
            this.props.handleMouseDown(childModel, e);
        }
    };
    @dispatchProps()
    public handleMouseUp = (childModel, e) => {
        const { isRootGroup } = this.props.component;
        if (isRootGroup) {
            this.handleMouseUpPresenter(childModel, e);
        } else {
            this.props.handleMouseUp(childModel, e);
        }
    };

    @external()
    public getCloneDom = () => {
        const contentRoot = this.getChildRef('contentRef').cloneNode(false);
        this.props.component?.children.forEach((obj) => {
            const componentRef = this.getChildRef(obj.key);
            const cloneDom = componentRef.elementWrapperRef.getCloneDom?.();
            cloneDom && contentRoot.appendChild(cloneDom);
        });
        return [
            contentRoot,
        ];
    };

    private reportOnSelect = (model) => {
        if (this.getUserPriviledgeService().pptEditorState !== PPTEditorStateType.EDITABLE) return;
        let action: null | string = null;
        if (model.type === UIModelType.SHAPE) {
            action = TDWActionType.CLK_EDIT;
        } else if (model.type === UIModelType.IMAGE) {
            action = TDWActionType.CLK_IMG;
        }
        if (action) {
            tdw({
                opername: TDWOperationType.DOC_PPT,
                module: TDWModuleType.PC_OBJ,
                action,
            });
        }
    };
    private tdwHandleMouseDown = (childModel) => {
        let action: null | string = null;
        switch (childModel.type) {
            case UIModelType.SHAPE:
                action = childModel.subType === 1 ? TDWActionType.EDIT_TEXT : TDWActionType.EDIT_SHAPE;
                break;
            case UIModelType.IMAGE:
                action = TDWActionType.EDIT_IMG;
                break;
            case UIModelType.TABLE:
                action = TDWActionType.EDIT_FORM;
                break;

            default:
                break;
        }
        if (action) {
            // console.log('water group action = ',action);
            tdw({
                opername: TDWOperationType.DOC_PPT,
                module: TDWModuleType.PC_OBJ,
                action,
            });
        }
    };
    // handleMouseUpPresenter拆分
    private updateSelectedElement = (e, childModel) => {
        if (this.getAppServices().viewableServiceLayer.selectionService.selectedElements
            .selectedArrayForType(SelectedEleMgrType.GROUP).length === 0) {
            this.needMouseUp = true;
            e.preventDefault();
            e.stopPropagation(); // 会影响组合
        } else {
            e.preventDefault();
            e.stopPropagation();
            if (e.metaKey || e.shiftKey || e.ctrlKey) { // shift/control/command按住时多选
                if (childModel.selected) {
                    this.needMouseUp = true;
                } else {
                    this.getAppServices().viewableServiceLayer.selectionService.selectedElements.add(childModel);
                    this.reportOnSelect(childModel);
                }
            } else if (!childModel.selected) {
                this.getAppServices().viewableServiceLayer.selectionService
                    .selectedElements.clear(SelectedEleMgrType.GROUP);
                this.getAppServices().viewableServiceLayer.selectionService.selectedElements.add(childModel);
                this.reportOnSelect(childModel);
                this.getAppServices().viewableServiceLayer.editingStateManager.updateElementCropState(false);
            }
        }

        if (childModel.type !== UIModelType.TABLE) {
            this.getAppServices().editableServiceLayer?.dragElementHandler.handleMouseDownOnElement(
                e,
                childModel,
                this.props.getPageScale(),
                this.needMouseUp,
                () => {
                    this.needMouseUp = false;
                },
            );
        }
    };
    private handleMouseDownPresenter = (childModel, e) => {
        (this.getAppServices() as IPcEditorAppServices).editableServiceLayer?.selectedAnims?.clear();
        // group 嵌套往上传递
        if (this.props.handleMouseDown && !this.props.component.isRootGroup && !this.props.isGroupChildren) {
            this.props.handleMouseDown(childModel, e);
        } else if (this.props.component.selected
            && this.getAppServices().viewableServiceLayer.selectionService.selectedElements.
                selectedArrayForType(SelectedEleMgrType.SLIDE).length === 1) {
            // tdw 上报逻辑
            {
                this.tdwHandleMouseDown(childModel);
            }

            this.updateSelectedElement(e, childModel);
        }
    };

    private handleMouseUpPresenter = (childModel, e) => {
        if (this.props.handleMouseUp && !this.props.component.isRootGroup && !this.props.isGroupChildren) {
            this.props.handleMouseUp(childModel, e);
        } else if (this.needMouseUp === true) {
            if (!childModel.selected) {
                this.getAppServices().viewableServiceLayer.selectionService.selectedElements.add(childModel);
            } else {
                this.getAppServices().viewableServiceLayer.selectionService.selectedElements.remove(childModel);
            }
            this.reportOnSelect(childModel);
            this.needMouseUp = false;
        }
    };

    private getAppServices(): IEditorAppServices {
        return AppServiceProvider.getInstance().getAppServices() as
            IEditorAppServices;
    }

    private getUserPriviledgeService(): IUserPriviledgeService {
        return this.getAppServices().viewableServiceLayer.userPriviledgeService;
    }
}
